module.exports = __webpack_public_path__ + "fonts/fa-brands-400.ec5a2a6.eot";